import { createSlice } from "@reduxjs/toolkit";
import { PayloadAction } from "@reduxjs/toolkit/src/createAction";

import { IUserModel, IUserProfessionModel, IUserRoleModel } from "../../data/models/user";

interface IState {
  roles: IUserRoleModel[];
  professions: IUserProfessionModel[];
  users: IUserModel[];
}

const INITIAL_STATE: IState = {
  roles: [],
  professions: [],
  users: [],
};

export const usersSlice = createSlice({
  name: "users",
  initialState: INITIAL_STATE,
  reducers: {
    setUsers: (state, action: PayloadAction<IUserModel[]>) => {
      state.users = action.payload;
    },
    setRoles: (state, action: PayloadAction<IUserRoleModel[]>) => {
      state.roles = action.payload;
    },
    setProfessions: (state, action: PayloadAction<IUserProfessionModel[]>) => {
      state.professions = action.payload;
    },
    bulkDeleteProfessions: (state, action: PayloadAction<string[]>) => {
      const ids = action.payload;
      state.professions = state.professions.filter((profession) => !ids.includes(profession.id));
    },
    addProfession: (state, action: PayloadAction<IUserProfessionModel>) => {
      state.professions.push(action.payload);
    },
    updateProfession: (state, action: PayloadAction<IUserProfessionModel>) => {
      const professionIndex = state.professions.findIndex((profession) => profession.id === action.payload.id);
      state.professions[professionIndex] = action.payload;
    },
    addUser: (state, action: PayloadAction<IUserModel>) => {
      state.users.push(action.payload);
    },
    bulkDeleteUsers: (state, action: PayloadAction<string[]>) => {
      state.users = state.users.filter((user) => !action.payload.includes(user.id));
    },
    updateUser: (state, action: PayloadAction<IUserModel>) => {
      const userIndex = state.users.findIndex((user) => user.id === action.payload.id);
      state.users[userIndex] = action.payload;
    },
  },
});

export const {
  setUsers,
  setRoles,
  setProfessions,
  addProfession,
  updateProfession,
  bulkDeleteProfessions,
  addUser,
  bulkDeleteUsers,
  updateUser,
} = usersSlice.actions;

export default usersSlice.reducer;
